import React from "react"
import {
  ForgotPassword as ForgotPasswordComponent
} from '../components/userActions';

const ForgotPassword = () => <ForgotPasswordComponent />

export default ForgotPassword
